import type { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { clsx } from 'clsx';

interface LabelProps {
    htmlFor?: string;
    /** Optional element id, so a group (e.g. a radiogroup) can reference the label via aria-labelledby. */
    id?: string;
    children: ReactNode;
    className?: string;
    /** Render a red required indicator (*) after the label text. */
    required?: boolean;
}

export const Label: FC<LabelProps> = ({ htmlFor, id, children, className, required = false }) => {
    return (
        <label
            htmlFor={htmlFor}
            id={id}
            className={clsx(
                twMerge(
                    'mb-1.5 block text-sm font-medium text-mp-foreground',
                    className
                )
            )}
        >
            {children}
            {required && (
                <>
                    <span aria-hidden="true" className="text-mp-error"> *</span>
                    <span className="sr-only"> (required)</span>
                </>
            )}
        </label>
    );
};
